import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import { showInfo } from '../../../common/A1Alert/A1Alert';

// Set here the new pages to show "novo" in the right side
// it's static for while
// const newPages = [];

class MenuFooter extends Component {
    componentDidMount() {
        if (this.props.defaultOpen) {
            const menuCollapsed = document.querySelector(`.item-menu.${this._cleanTitle()}`).querySelector('.menu-collapsed');
            const iconCollapsed = document.querySelector(`.item-menu.${this._cleanTitle()}`).querySelector('.icon-collapsed');
            const iconExpanded = document.querySelector(`.item-menu.${this._cleanTitle()}`).querySelector('.icon-expanded');

            if (menuCollapsed && iconCollapsed && iconExpanded) {
                menuCollapsed.classList.remove('slideOutUp');

                menuCollapsed.classList.add('slideInDown');

                iconCollapsed.classList.add('hidden');

                iconExpanded.classList.remove('hidden');
            }
        }
    }

    _onClick = (e, to) => {
        const target = e.target;

        if (target.className.split(' ')[1] !== 'ExternalLink' && this.props.pathname !== '/' && target.href.indexOf(this.props.pathname) > 0) {
            // avoid double crolling (only scroll to top if link of current page is clicked)
            // the rest should be handled by the corresponding page it self
            // note: we are explicitly excluding the home path for now (as there is not link to it in the footer and it would cause all pages to double scroll)
            animateScrollTo(0, { speed: 700 });
        }

        if (to === '/#') {
            e.preventDefault();

            showInfo('Essa página ainda não foi implementada :/ Mas já estamos trabalhando nela!');
        }
    }

    _cleanTitle() {
        // Build a stable class/id token from menu titles by stripping accents and spaces.
        // Example: "São Paulo" -> "SaoPaulo".
        return this.props.titleMenu
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replaceAll(' ', '');
    }

    _showItensMenu() {
        return this.props.listMenu.map((data) => {
            const faIcon = data.faIcon;

            return (
                <li
                    className={`${data.to === '/#' ? 'disabled' : ''}`}
                    key={data.title}
                >
                    {faIcon != null ? <FontAwesomeIcon className="fa-lg" icon={faIcon} style={{ marginRight: 5 }} /> : ''}
                    {data.externalLink ?
                        <Button href={data.to} title={data.title}>
                            {data.title}
                        </Button>
                        :
                        <Button
                            to={data.to}
                            title={data.title}
                            onClick={(e) => this._onClick(e, data.to)}
                        >
                            {data.title}
                        </Button>}
                    {/* {newPages.includes(data.title) && <span className="newPages">NOVO</span>} */}
                </li>
            );
        });
    }

    render() {
        // Reuse the same normalization used by selectors and data-id.
        const titleMenuClean = this._cleanTitle();

        return (
            <div className={`item-menu ${titleMenuClean}`} data-id={titleMenuClean}>
                <div className="item-menu-header">
                    <h3>
                        {this.props.titleMenu}
                    </h3>
                    <FontAwesomeIcon className="iconPlusFooter icon-collapsed" icon={faChevronRight} height={10} />
                    <FontAwesomeIcon icon={faChevronDown} className="iconPlusFooter icon-expanded hidden" height={10} />
                </div>
                <ul className="menu-collapsed slideOutUp">
                    {this._showItensMenu()}
                </ul>
            </div>
        );
    }
}

MenuFooter.propTypes = exact({
    titleMenu: PropTypes.string,
    listMenu: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        icon: PropTypes.string,
        externalLink: PropTypes.string,
    })),
    pathname: PropTypes.string,
    defaultOpen: PropTypes.bool,
});


export default MenuFooter;
